import React from 'react';
import { AlertTriangle } from 'lucide-react';

/**
 * Warning banner displayed when user has 2+ strikes.
 * Shows amber for 2 strikes, red for 3+ (locked).
 *
 * Returns null if strikeCount < 2 (no warning needed).
 *
 * @param {number} strikeCount - Current number of strikes
 * @param {boolean} isLocked - Whether account is locked
 */
export default function StrikeWarningBanner({ strikeCount, isLocked = false }) {
  if (strikeCount < 2) return null;

  const isDanger = strikeCount >= 3 || isLocked;

  return (
    <div className={`${
      isDanger ? 'bg-red-50 border-red-300' : 'bg-amber-50 border-amber-300'
    } border rounded-lg p-3 mb-4 flex items-center gap-3`}>
      <AlertTriangle className={`h-5 w-5 flex-shrink-0 ${
        isDanger ? 'text-red-600' : 'text-amber-600'
      }`} />
      <div className={`text-sm ${isDanger ? 'text-red-800' : 'text-amber-800'}`}>
        {isLocked ? (
          <>
            <span className="font-medium">Account Locked:</span> You have {strikeCount} strikes.
            Contact admin to unlock your account.
          </>
        ) : (
          <>
            <span className="font-medium">Warning:</span> You have {strikeCount} strikes.
            {strikeCount === 2 && ' One more strike will lock your account.'}
          </>
        )}
      </div>
    </div>
  );
}
